import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

/**
 * ===============================
 * CLIENT FAQ SERVICE
 * ===============================
 */

/**
 * Get all FAQs
 */
export const fetchAllFaqs = async () => {

  try {

    const response = await api.get("/public/faqs");

    return {
      status: response.status,
      data: response.data,
    };

  } catch (err) {

    return {
      status: err.response?.status || 500,
      data: [],
      message:
        err.response?.data?.message ||
        err.message ||
        "Failed to fetch FAQs",
    };

  }

};